module.exports = __webpack_public_path__ + "img/login-santarita.de42f0b3.svg";